import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CasepaperComponent} from './casepaper.component';
import {routing} from './casepaper.routing';
import {MstVisitService} from "../configuration/mst-visit/mst-visit.service";
import {MstUnitService} from "../configuration/mst-unit/mst-unit.service";
import {PanelModule} from "primeng/primeng";
import {NgxBarcodeModule} from "ngx-barcode";
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {TemrVitalService} from '../configuration/temr-vital/temr-vital.service';
import {LayoutModule} from '../layout/layout.module';

@NgModule({
  imports: [
    CommonModule,
    PanelModule,
    NgxBarcodeModule, SharedTranslationModule,LayoutModule,
    routing
  ],
  declarations: [CasepaperComponent],
  providers:[ MstVisitService, MstUnitService, TemrVitalService]
})
export class CasepaperModule { }



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/casepaper/casepaper.module.ts